export default {
  initialize: state => ({
    type: 'SORTING_INITIALIZE',
    state,
  }),
  setSortOptions: sortOptions => ({
    type: 'SORTING_SET_SORT_OPTIONS',
    sortOptions,
  }),
  setActiveSort: activeSort => ({
    type: 'SORTING_SET_ACTIVE_SORT',
    activeSort,
  }),
  setSortSelection: sortSelection => ({
    type: 'SORTING_SET_SORT_SELECTION',
    sortSelection,
  }),
  setSortSelectionKey: sortSelectionKey => ({
    type: 'SORTING_SET_SORT_SELECTION_KEY',
    sortSelectionKey,
  }),
  setSortSelectionDirection: sortSelectionDirection => ({
    type: 'SORTING_SET_SORT_SELECTION_DIRECTION',
    sortSelectionDirection,
  }),
};
